import { Textarea } from '@/components/common/Textarea'
import { StepShell } from '../StepShell'

const DEFAULT = {
  special_precautions: '',
  follow_up_advice: '',
  emergency_instructions: '',
}

export function DoctorNotesStep({ value, onChange }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 14 — Phase 5"
      title="Doctor notes"
      description="Final word from the doctor — precautions and follow-up."
    >
      <Textarea
        label="Special precautions"
        rows={3}
        value={v.special_precautions}
        onChange={(e) => set({ special_precautions: e.target.value })}
        placeholder="e.g. Avoid hard / hot food for 24 hours"
      />
      <Textarea
        label="Follow-up advice"
        rows={3}
        value={v.follow_up_advice}
        onChange={(e) => set({ follow_up_advice: e.target.value })}
        placeholder="e.g. Review in 1 week for second sitting of RCT"
      />
      <Textarea
        label="Emergency instructions"
        rows={3}
        value={v.emergency_instructions}
        onChange={(e) => set({ emergency_instructions: e.target.value })}
        placeholder="Whom to contact if pain / swelling worsens"
      />
    </StepShell>
  )
}
